"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableWithNavigation = TableWithNavigation;
var _useScrollToElement = require("../../../hooks/useScrollToElement/useScrollToElement");
var _react = _interopRequireWildcard(require("react"));
var _TableFooter = require("../table-footer/TableFooter");
var _Table = require("../table/Table");
function TableWithNavigation(_ref) {
  var columns = _ref.columns,
    data = _ref.data,
    testId = _ref.testId,
    pageSize = _ref.pageSize,
    noResultsComponent = _ref.noResultsComponent,
    onRowClick = _ref.onRowClick,
    createOnColumnSort = _ref.createOnColumnSort,
    sortByColumn = _ref.sortByColumn,
    totalItemsCount = _ref.totalItemsCount,
    changeCurrentPage = _ref.changeCurrentPage,
    currentPage = _ref.currentPage,
    changePageSize = _ref.changePageSize,
    totalPageCount = _ref.totalPageCount,
    horizontalScrollWidth = _ref.horizontalScrollWidth,
    hasThreeStateSorting = _ref.hasThreeStateSorting,
    dataName = _ref.dataName,
    BodyRowComponent = _ref.BodyRowComponent;
  var tableRef = (0, _react.useRef)(null);
  var scrollToHeader = (0, _useScrollToElement.useScrollToElement)(tableRef);
  var handlePageChange = (0, _react.useCallback)(function (pageIndex) {
    changeCurrentPage(pageIndex);
    scrollToHeader();
  }, [scrollToHeader, changeCurrentPage]);
  var handleSizeChange = (0, _react.useCallback)(function (size) {
    changePageSize(size);
    scrollToHeader();
  }, [scrollToHeader, changePageSize]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Table.Table, {
    innerRef: tableRef,
    horizontalScrollWidth: horizontalScrollWidth,
    columns: columns,
    data: data,
    testId: testId,
    pageSize: pageSize,
    noResultsComponent: noResultsComponent,
    onRowClick: onRowClick,
    createOnColumnSort: createOnColumnSort,
    sortByColumn: sortByColumn,
    hasThreeStateSorting: hasThreeStateSorting,
    BodyRowComponent: BodyRowComponent
  }), totalItemsCount !== undefined && /*#__PURE__*/_react.default.createElement(_TableFooter.TableFooter, {
    changeCurrentPage: handlePageChange,
    currentPage: currentPage,
    changePageSize: handleSizeChange,
    pageSize: pageSize,
    totalItemsCount: totalItemsCount,
    totalPageCount: totalPageCount,
    dataName: dataName
  }));
}